<template>
    <div>
        <div @click="onChange('active')" v-if="active && !disabled" class="checkbox-active d-flex justify-content-center align-items-center">
                <img src="~@/assets/icon/check-white.svg" alt="check">
            </div>
        <div @click="onChange('partial')" v-if="partial && !disabled" class="checkbox bg-dark-grey d-flex justify-content-center align-items-center">
                <img src="~@/assets/icon/dash-white.svg" alt="dash">
            </div>
        <div @click="onChange('inactive')" v-if="!active && !partial && !disabled" class="checkbox"></div>
        <div v-if="disabled" class="checkbox-disabled d-flex justify-content-center align-items-center">
          <img v-if="active" src="~@/assets/icon/check-gray.svg" alt="check">
          <img v-if="partial" src="~@/assets/icon/dash-gray.svg" alt="dash">
        </div>
    </div>
</template>

<script>

export default {
  name: "Checkbox",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    partial: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    onChange(type) {
        const value = {
            active: type === 'active',
            partial: type === 'partial',
        }
        if (!this.active && !this.partial) {
            value.active = true
            value.partial = false
        } else if (this.partial) {
            value.active = true
            value.partial = false
        } else if (this.active || this.partial) {
            value.active = false
            value.partial = false
        }
        this.$emit('change', value)
    },
  },
};

</script>

<style scoped>
.checkbox {
  width: 16px;
  height: 16px;
  border: 1px solid #555358;
  border-radius: 4px;
  cursor: pointer;
}

.checkbox-active {
  width: 16px;
  height: 16px;
  border: 1px solid #247fec;
  border-radius: 4px;
  cursor: pointer;
  background-color: #247fec;
}

.bg-dark-grey {
  background-color: #555358;
}

.checkbox-disabled {
  background-color: #F4F4F4;
  border: 1px solid #DDDDDE;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  cursor: not-allowed;
}

</style>


// WEBPACK FOOTER //
// src/components/Input/Checkbox.vue